import { gearTemplate, setPieceId } from './biome-sets.js';
/**
 * Shefira's set (ADR 0068, §6): the best gear in the game, found on the
 * dragon alone, a piece per participant and per game week (`rollRaidLoot`,
 * `data/loot.ts`). Six pieces drawn for it, epic and legendary only.
 *
 * Worn at level 20, the cap, but measured as if found at `RAID_POWER_LEVEL`:
 * its epic outdoes the peaks' legendary, its legendary Eirik's sword, so the
 * raid is worth doing again once the story is over.
 *
 * Out of every biome's pool — the peaks' band reaches level 20, so these
 * pieces are not `lootable` — yet they carry affixes (ADR 0057) like found
 * gear: `source: 'raid'` says so, and where their power comes from.
 */
export const RAID_POWER_LEVEL = 26;
export const RAID_GEAR_LEVEL = 20;
export const RAID_RARITIES = ['epic', 'legendary'];
export const RAID_SET = {
    // Ser Givrecoeur's sword, taken back from Shefira's flank.
    weapon: { id: 'givrecoeur-oath', name: 'Serment de Givrecoeur' },
    offhand: { id: 'shefira-shield', name: 'Écu de Shefira' },
    helmet: { id: 'shefira-helm', name: 'Heaume de Shefira' },
    chest: { id: 'shefira-chest', name: 'Cuirasse de Shefira' },
    gloves: { id: 'shefira-gloves', name: 'Gantelets de Shefira' },
    boots: { id: 'shefira-boots', name: 'Grèves de Shefira' },
};
/** The level a template's stats and affixes are measured at: the raid's own for its set. */
export function powerLevelOf(template) {
    return template.source === 'raid' ? RAID_POWER_LEVEL : template.levelRequired;
}
export const RAID_GEAR_TEMPLATES = Object.entries(RAID_SET).flatMap(([slot, { id, name }]) => RAID_RARITIES.map((rarity) => gearTemplate({
    id: setPieceId(id, rarity),
    name,
    slot,
    rarity,
    level: RAID_GEAR_LEVEL,
    powerLevel: RAID_POWER_LEVEL,
    art: id,
    lootable: false,
    source: 'raid',
    // The same rank the affixes measure their power with (`affixPowerOf`).
    rank: rarity === 'epic' ? 2 : 3,
})));
//# sourceMappingURL=raid-gear.js.map